/**
 * -TODAS LAS IMAGENES DE BIBLIOTECAS DEBEN IR ACÁ, CUALQUIER REFERENCIA A IMAGENES DE BIBLIOTECAS DEBE SALIR DE ACÁ.
 */
export const ALL_LIBRARYS_IMAGES = [
	{
		location: "",
		lang: "es",
		name: "Universidad de los andes",
		src: "/img/bibliotecas/Andes.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "Austin public librarie",
		src: "/img/bibliotecas/austin.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "Banco de la república",
		src: "/img/bibliotecas/Banrep.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "Berkeley public library",
		src: "/img/bibliotecas/Berkeley.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "Biblioteca Nacional de colombia",
		src: "/img/bibliotecas/BiblioNal.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "Biblored",
		src: "/img/bibliotecas/Bibliored.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "Santa marta",
		src: "/img/bibliotecas/biblioteca-santa-marta.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "Boston public library",
		src: "/img/bibliotecas/Boston.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "Cajacopi",
		src: "/img/bibliotecas/cajacopi.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "Casa de la literatura peruana",
		src: "/img/bibliotecas/casaliteraturaperuana.jpg",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "Centro erducativo y cultural del estado Gómez morin",
		src: "/img/bibliotecas/centro-gomez-morin.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "Charlotte mecklenburg library",
		src: "/img/bibliotecas/Charlotte.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "Colsubsidio",
		src: "/img/bibliotecas/colsubsidio.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "Comfacauca",
		src: "/img/bibliotecas/comfacauca.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "Comfama",
		src: "/img/bibliotecas/comfama.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "Bibliotecas comfamiliar risaralda",
		src: "/img/bibliotecas/Comfamiliar Risaralda.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "comfamiliar",
		src: "/img/bibliotecas/comfamiliarHuila.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "Comfenalco Valle",
		src: "/img/bibliotecas/Comfenalco Valle.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "Comfenalco antioquia",
		src: "/img/bibliotecas/ComfenalcoAnt.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "Comfenalco",
		src: "/img/bibliotecas/ComfenalcoAtl.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},

	{
		location: "",
		lang: "es",
		name: "Comfenalco quindio",
		src: "/img/bibliotecas/comfenalcoQuin.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "compensar",
		src: "/img/bibliotecas/compensar.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "corvallis benton county public library",
		src: "/img/bibliotecas/corvallis-benton-county.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "denver public library",
		src: "/img/bibliotecas/denver.jpg",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "biblioteca epm",
		src: "/img/bibliotecas/epm.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "fresno county public library",
		src: "/img/bibliotecas/Fresno.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "Fundalectura",
		src: "/img/bibliotecas/Fundalectura.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "Garfield county libraries",
		src: "/img/bibliotecas/garfield-county-libraries.jpg",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "hialeah public libraries",
		src: "/img/bibliotecas/Hialeah.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "pontificia universidad javeriana",
		src: "/img/bibliotecas/Javeriana.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "King county library system",
		src: "/img/bibliotecas/king-county.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "longbeach public library",
		src: "/img/bibliotecas/LBPL.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "unab",
		src: "/img/bibliotecas/unab.jpg",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "los angeles public library",
		src: "/img/bibliotecas/LosAngeles.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "public miami dade library system",
		src: "/img/bibliotecas/Miami.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "mineducacion",
		src: "/img/bibliotecas/mineducacion.jpg",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "ministerio-de-educacion",
		src: "/img/bibliotecas/ministerio-de-educacion.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "north miami beach public library",
		src: "/img/bibliotecas/north-miami-beach-public-library.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},

	{
		location: "usa",
		lang: "en",
		name: "Oakland",
		src: "/img/bibliotecas/Oakland.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "public library pflugerville texas",
		src: "/img/bibliotecas/pflugerville.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "biblioteca pública piloto",
		src: "/img/bibliotecas/piloto.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "pioneer library system",
		src: "/img/bibliotecas/pioneer-library-system.jpg",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "prince george county memorial library system",
		src: "/img/bibliotecas/prince.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "queens public library",
		src: "/img/bibliotecas/Queens.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "red de bibliotecas públicas de cali",
		src: "/img/bibliotecas/RBPC.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "sacramento public library",
		src: "/img/bibliotecas/sacramento-public-library.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "san jose public library",
		src: "/img/bibliotecas/sanjose-public-library.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},

	{
		location: "",
		lang: "es",
		name: "secretaria de educacion",
		src: "/img/bibliotecas/secretaria-de-educacion.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "sonoma county library",
		src: "/img/bibliotecas/sonoma-county-library.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "universidad de los andes",
		src: "/img/bibliotecas/u-los-andes.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "universidad de la salle",
		src: "/img/bibliotecas/universidad-la-salle.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "upb",
		src: "/img/bibliotecas/upb.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "es",
		name: "uptc",
		src: "/img/bibliotecas/uptc.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "w j niederkorn-library",
		src: "/img/bibliotecas/w-j-niederkorn-library.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "usa",
		lang: "en",
		name: "city of whittier california",
		src: "/img/bibliotecas/whittier.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "biblioteca central estatal wigberto jimenez moreno",
		src: "/img/bibliotecas/Wigberto.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},
	{
		location: "",
		lang: "en",
		name: "goshen",
		src: "/img/bibliotecas/goshen.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "en",
		name: "champaign public library",
		src: "/img/bibliotecas/champaign-public-library.jpg",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "en",
		name: "arapahoe libraries",
		src: "/img/bibliotecas/arapahoe-libraries.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "en",
		name: "williamsburg regional library",
		src: "/img/bibliotecas/williamsburg-regional-library.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "san antonio public library",
		src: "/img/bibliotecas/san-antonio-public-library.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: true
		},
	},
	{
		location: "",
		lang: "es",
		name: "fundacion universitaria tecnologico comfenalco",
		src: "/img/bibliotecas/fundacion-universitaria-tecnologico-comfenalco.png",
		visibleFor: {
			"que-es": true,
			bibliotecas: true,
			usa: false
		},
	},

];
